export const getFilterRules = state => state.filterRules;